module.exports = __webpack_public_path__ + "static/media/HCMM962.239ac768.jpg";